import Banner from "common/components/subscriptions/Banner";
import usePromotions from "common/datahooks/usePromotions";

export default function Alerts({
  seatCount,
  includedSeats,
}: {
  seatCount: number;
  includedSeats: number;
}) {
  const { agencyPlan } = usePromotions();

  if (agencyPlan) {
    const { license_count, unassigned_license_count } = agencyPlan;
    const assignedLicenseCount = license_count - unassigned_license_count;

    if (seatCount < assignedLicenseCount) {
      return (
        <Banner
          textNode="Cannot downgrade subscription while seats are in use. Unassign the seats you want to remove, then try again"
          variant="warning"
        />
      );
    }
    if (seatCount === includedSeats) {
      return (
        <Banner
          textNode="Subscription is currently at the minimum number of seats"
          variant="info"
        />
      );
    }
  }
}
